import { render } from "./BusinessCRUD.vue?vue&type=template&id=03a7c3f9&scoped=true"
import script from "./BusinessCRUD.vue?vue&type=script&lang=js"
export * from "./BusinessCRUD.vue?vue&type=script&lang=js"

import "./BusinessCRUD.vue?vue&type=style&index=0&id=03a7c3f9&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a7c3f9"]])

export default __exports__